import { useSelector } from 'react-redux';

import { FILTER_LOCATION_NAME } from 'dpl/constants/query_params';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { singleBreederProfileResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

export function useBreederProfileData() {
  const breederProfileId = useSelector(
    ({ server }: any) => server.breederProfileId
  );
  const locName = useSelector(
    ({ queryParams }: any) => queryParams[FILTER_LOCATION_NAME]
  );

  const { value: breeder, isFetching: isFetchingBreeder } = useResourceQuery(
    singleBreederProfileResourceDefinition(breederProfileId, { locName })
  );

  const shareMeta = breeder.share_meta;

  return {
    breeder,
    breederProfileId,
    locName,
    shareMeta,
    isFetchingBreeder
  };
}
